module.exports = __webpack_public_path__ + "static/media/carnes.65cc47d7.jpg";